import { Handle, type NodeProps, type Node } from "@xyflow/react";
import type { WorkflowNodeData } from "../../lib/workflow-graph";
import { handlePositions, type HandleDirection } from "./handles";
import LinkHandles from "./LinkHandles";
import styles from "./WorkflowNode.module.css";

export default function TriggerNode({ data }: NodeProps<Node>) {
  const d = data as unknown as WorkflowNodeData & {
    direction?: HandleDirection;
  };
  const { source } = handlePositions(d.direction);
  return (
    <div className={`${styles.card} ${styles.trigger}`}>
      <p className={styles.kind}>Trigger</p>
      <p className={styles.label}>{d.label}</p>
      {d.subtitle && <p className={styles.subtitle}>{d.subtitle}</p>}
      <Handle type="source" position={source} />
      <LinkHandles />
    </div>
  );
}
